<template>
    <div class="rating-stars">
        <div v-if="dense">
            <rating-star :value="1" />
        </div>
        <template v-else>
            <rating-star v-for="(i, index) in [1, 2, 3, 4, 5]" :key="index" :value="Math.min(1, Math.max(0, value - i + 1))" />
        </template>
    </div>
</template>

<script>
import RatingStar from './RatingStar.vue';

export default {
    components: {
        RatingStar,
    },
    props: {
        dense: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.rating-stars {
    display: flex;
    align-items: center;
}
.rating-stars-value {
    font-weight: bold;
    margin-top: 2px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Rating.vue